export const Text = {
    
    initials: (firstWord = '', secondWord = '') => `${firstWord.charAt(0)}${secondWord.charAt(0)}`,

    formatSlug: (string) =>
    {
        const slug = string.split('-');

        return { full: slug, code: slug[0] };
    },
    
    joinClass: (...args) =>
    {
        let classnames = '';

        for (let i = 0; i < args.length; i++)
        {
            if (args[i])
            {
                classnames += (`${args[i]} `);
            }
        }
    
        return classnames;
    },

    formUrl: (query, path, page) =>
    {
        if (query && Object.keys(query).length > 0)
        {
            Object.keys(query).forEach((key, index) => {
                path += !index ? '?' : '&';

                if (key == 'page')
                {
                    path += `page=${page}`;
                }
                else
                {
                    path += `${key}=${query[key]}`;
                }
            });

            if (!path.includes('page=')) path += `&page=${page}`;
        }
        else
        {
            path += `?page=${page}`;
        }

        return path;
    },

    titleCase: (string) =>
    {
        return string.split(' ')
                .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
                .join(' ');
    },
};



// WEBPACK FOOTER //
// ./src/utils/text.js